import { makeStyles, tokens } from '@fluentui/react-components';
import ReviewToolstrip from '../Shared/ReviewToolstrip';

interface ReviewFooterProps {
	user: string;
	gameId: number;
	gameTitle: string;
}

const ReviewFooter = (props: ReviewFooterProps) => {
	const styles = useStyles();

	return (
		<div className={styles.root}>
			<ReviewToolstrip
				title={`More Reviews by ${props.user}`}
				username={props.user}
			/>

			<ReviewToolstrip
				title={`More ${props.gameTitle} Reviews`}
				gameId={props.gameId}
				justifyContent='right'
			/>
		</div>
	);
};

export default ReviewFooter;

const useStyles = makeStyles({
	root: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-around',
		backgroundColor: tokens.colorNeutralBackground5,
		padding: '15px'
	},
	reviews: {
		display: 'flex',
		columnGap: '3px',
		alignItems: 'center'
	},
	image: {
		height: '50px',
		width: '50px',
		cursor: 'pointer'
	}
});
